import { useTranslation } from 'react-i18next';

import { PromoCodeStatus } from '../../../stores/types/promoCode.interface';
import { ColorType } from '../../_ui';
import { StatusPill } from '../StatusPill.component';

interface PromoCodeStatusStyle {
  borderColor: ColorType;
  labelColor: ColorType;
  bgColor: ColorType | string;
  labelKey: string;
}

const STATUS_STYLES: Record<PromoCodeStatus, PromoCodeStatusStyle> = {
  [PromoCodeStatus.DRAFT]: {
    borderColor: ColorType.GREY5,
    labelColor: ColorType.GREY5,
    bgColor: ColorType.GREY1,
    labelKey: 'draft',
  },
  [PromoCodeStatus.ACTIVE]: {
    borderColor: ColorType.POSITIVE,
    labelColor: ColorType.POSITIVE,
    bgColor: ColorType.POSITIVE_LIGHT,
    labelKey: 'active',
  },
  [PromoCodeStatus.PAUSED]: {
    borderColor: ColorType.PAUSED,
    labelColor: ColorType.PAUSED,
    bgColor: ColorType.WARNING_LIGHT,
    labelKey: 'paused',
  },
  [PromoCodeStatus.SCHEDULED]: {
    borderColor: ColorType.DENIM,
    labelColor: ColorType.DENIM,
    bgColor: ColorType.BRAND0,
    labelKey: 'scheduled',
  },
  [PromoCodeStatus.EXPIRED]: {
    borderColor: ColorType.NEGATIVE,
    labelColor: ColorType.NEGATIVE,
    bgColor: ColorType.NEGATIVE_LIGHT,
    labelKey: 'expired',
  },
  [PromoCodeStatus.DEPLETED]: {
    borderColor: ColorType.NEGATIVE,
    labelColor: ColorType.NEGATIVE,
    bgColor: ColorType.NEGATIVE_LIGHT,
    labelKey: 'depleted',
  },
  [PromoCodeStatus.DELETED]: {
    borderColor: ColorType.GREY6,
    labelColor: ColorType.WHITE,
    bgColor: ColorType.GREY6,
    labelKey: 'archived',
  },
};

const PromoCodeStatusPill = ({ status }: { status: PromoCodeStatus }) => {
  const { t } = useTranslation();
  const style = STATUS_STYLES[status] ?? STATUS_STYLES[PromoCodeStatus.DRAFT];

  return (
    <StatusPill
      label={t(style.labelKey)}
      borderColor={style.borderColor}
      labelColor={style.labelColor}
      bgColor={style.bgColor}
    />
  );
};

export default PromoCodeStatusPill;
